import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import { getErrorValidateWithId } from '../../../utilities/works';

const InputTemplate = ({
  context,
  grid,
  column,
  handlePushParam,
  msgValidate,
  maxLength,
  tabKeyStatus,
}) => {
  const { isAbortedOrApproved } = context.item;
  const [data, setData] = useState(context.item[column] || '');

  useEffect(() => {
    setData(context.item[column] || '');
  }, [context.item[column]]);

  const handleOnchange = e => {
    if (isAbortedOrApproved) {
      return;
    }
    setData(e.target.value);
  };

  const handleOnBlur = e => {
    if (
      isAbortedOrApproved ||
      e.target.value === (context.item[column] || '')
    ) {
      return;
    }
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem[column] = e.target.value;
    if (!v.currentItem['is_data_changed'][column]) {
      v.currentItem['is_data_changed'][column] = true;
    }
    v.commitEdit();
    handlePushParam(context.item);
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, column);
  };

  return (
    <CellContent
      errorMsg={getError()}
      isDataChanged={_.get(context, `item.is_data_changed.${column}`)}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <input
        type='text'
        disabled={isAbortedOrApproved}
        maxLength={maxLength}
        value={data}
        onChange={handleOnchange}
        onBlur={handleOnBlur}
        className='input-cell'
        tabIndex={tabKeyStatus}
      />
    </CellContent>
  );
};

export default InputTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/InputTemplate.jsx